export const HOW_TO_USE_WEB3 =
  'https://blog.safeheron.com/blog/product-and-solution/safeheron-solutions/safeheron-for-web3'
